import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      width: '100%',
    },
    grid: {
      overflow: 'scroll',
    },
    icon: {
      cursor: 'pointer',
    },
    text: {
      color: 'primary',
      paddingBottom: theme.spacing(0.75),
      paddingLeft: theme.spacing(),
    },
  };
};
